import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { services } from '../data/mock';

export default function Services() {
  const [open, setOpen] = useState(0);

  return (
    <section id="servicos" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 text-center">
          <p className="text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-4">
            Serviços
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-[color:var(--cream-100)]">
            O que <span className="italic text-[color:var(--gold-400)]">fazemos</span>
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          {services.map((s, i) => {
            const isOpen = open === i;
            return (
              <div
                key={s.number}
                className="border-b border-[color:var(--gold-500)]/15"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 py-8 text-left group"
                >
                  <div className="flex items-baseline gap-6">
                    <span className="font-serif italic text-sm text-[color:var(--gold-400)]/80">
                      {s.number}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl md:text-3xl text-[color:var(--cream-100)] group-hover:text-[color:var(--gold-400)] transition-colors">
                        {s.title}
                      </h3>
                      {!isOpen && (
                        <p className="mt-2 text-sm md:text-base text-[color:var(--cream-100)]/60 max-w-xl">
                          {s.tagline}
                        </p>
                      )}
                    </div>
                  </div>
                  <span className="text-[color:var(--gold-400)] mt-2 shrink-0">
                    {isOpen ? <Minus size={22} /> : <Plus size={22} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-in-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100 pb-8' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="pl-10 md:pl-14 pr-4 max-w-3xl">
                      <p className="text-[color:var(--cream-100)]/80 text-base leading-relaxed">
                        {s.description}
                      </p>
                      <ul className="mt-5 grid sm:grid-cols-2 gap-2">
                        {s.bullets.map((b) => (
                          <li
                            key={b}
                            className="text-sm text-[color:var(--cream-100)]/70 flex items-center gap-2"
                          >
                            <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--gold-400)]"></span>
                            {b}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
